import sjrpDesktop from "../shared/img/banner/conversao/sjrp/web.jpg";
import sjrpTablet from "../shared/img/banner/conversao/sjrp/tablet.jpg";
import sjrpMobile from "../shared/img/banner/conversao/sjrp/mobile.jpg";

import ribeiraoDesktop from "../shared/img/banner/conversao/ribeirao/web.jpg";
import ribeiraoTablet from "../shared/img/banner/conversao/ribeirao/tablet.jpg";
import ribeiraoMobile from "../shared/img/banner/conversao/ribeirao/mobile.jpg";

import campinasDesktop from "../shared/img/banner/conversao/campinas/web.jpg";
import campinasTablet from "../shared/img/banner/conversao/campinas/tablet.jpg";
import campinasMobile from "../shared/img/banner/conversao/campinas/mobile.jpg";

export const BANNERS = {
  conversao: {
    sjrp: {
      desktop: sjrpDesktop,
      tablet: sjrpTablet,
      mobile: sjrpMobile
    },

    ribeirao: {
      desktop: ribeiraoDesktop,
      tablet: ribeiraoTablet,
      mobile: ribeiraoMobile
    },

    campinas: {
      desktop: campinasDesktop,
      tablet: campinasTablet,
      mobile: campinasMobile
    }
  }
};